export default __webpack_public_path__ + "static/bg-awards-b4de783ebf36cbd24021bd7c4983b121.png";